<script setup lang="ts">
import { useTabsStore } from '@/stores/useTabsStore';
import { notificationsTabs } from '@/constants/tabs';

import tabsStyles from '@/styles/tabs.module.scss';

const tabsStore = useTabsStore();
</script>

<template>
  <div :class="[$style.smartNoticesTabs, tabsStyles.tabsWrapper]">
    <v-tabs v-model="tabsStore.tabs.notifications" :class="tabsStyles.tabs">
      <v-tab
        v-for="(tabValue, tabKey, tabIndex) in notificationsTabs"
        :key="tabKey"
        :value="tabKey"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        {{ tabValue }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.smartNoticesTabs {
  padding: 0 10px;
}
</style>
